// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1dxPK","head":"ProcedureTableInfo_head__21FWI"};